<!-- <template>
  <iframe
    :src="url"
    height="100%"
    width="100%"
    style="height: 100%; width: 100%"
  ></iframe>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      default: '/chet/',
    },
  },
}
</script> -->

<script setup>
import { CHET_URL } from '@/main'
import { onMounted, ref } from 'vue'
import store from '@/store'
import { addDash } from '@/utils/urlFormatters'

store.commit('SET_VIEW_STRUCTURES', false)

const loading = ref(true)

const onLoad = () => {
  loading.value = false
}
</script>

<template>
  <div class="d-flex flex-column h-100 w-100">
    <v-progress-linear
      v-if="loading"
      indeterminate
    />

    <iframe
      :src="addDash(CHET_URL)"
      title="CheT"
      :data-embedded="true"
      @load="onLoad"
      class="d-flex flex-column h-100 w-100 border-0"
      loading="lazy"
    />
  </div>
</template>
